"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Configuration = void 0;
class Configuration {
}
exports.Configuration = Configuration;
Configuration.apiUrl = 'https://api.kriptonio.com';
Configuration.rpcApiUrl = 'https://rpc.kriptonio.com';
Configuration.paymasterApiUrl = 'https://paymaster.kriptonio.com';
